import type { Module, ActionContext } from 'vuex';

import {
    SET_SIGN_UP_STEP,
    SET_REGILY_OPEN_STATE,
    SET_ACCOUNT_LINK_REQUESTED,
    SET_BANK_LINKING_COMPLETION,
    SET_DEPOSIT_AMOUNT,
    SET_BONUS_CODE,
} from './account.constants';
import type { IAccountState } from './account.constants';
import type { IAppState } from '../../constants';

export const getters = {
    signUpStep(state: IAccountState) {
        return state.step;
    },
    isRegilyOpen(state: IAccountState) {
        return state.isRegilyOpen;
    },
    isAccountLinkRequested(state: IAccountState) {
        return state.isAccountLinkRequested;
    },
    hasCompletedBankLinking(state: IAccountState) {
        return state.hasCompletedBankLinking;
    },
    depositAmount(state: IAccountState) {
        return state.depositAmount;
    },
    bonusCode(state: IAccountState) {
        return state.bonusCode;
    }
};

export const actions = {
    setSignUpStep(
        { commit }: ActionContext<IAccountState, IAppState>,
        step: number,
    ) {
        commit(SET_SIGN_UP_STEP, step);
    },
    setRegilyOpenState(
        { commit }: ActionContext<IAccountState, IAppState>,
        isOpen: boolean,
    ) {
        commit(SET_REGILY_OPEN_STATE, isOpen);
    },
    setAccountLinkRequested(
        { commit }: ActionContext<IAccountState, IAppState>,
        isRequested: boolean,
    ) {
        commit(SET_ACCOUNT_LINK_REQUESTED, isRequested);
    },
    setBankLinkingCompletion(
        { commit }: ActionContext<IAccountState, IAppState>,
        isCompleted: boolean,
    ) {
        commit(SET_BANK_LINKING_COMPLETION, isCompleted);
    },
    setDepositAmount(
        { commit }: ActionContext<IAccountState, IAppState>,
        depositAmount: number,
    ) {
        commit(SET_DEPOSIT_AMOUNT, depositAmount);
    },
    setBonusCode(
        { commit }: ActionContext<IAccountState, IAppState>,
        bonusCode: string,
    ) {
        commit(SET_BONUS_CODE, bonusCode);
    }
};

export const account: Module<IAccountState, IAppState> = {
    namespaced: true,
    state: {
        step: 1,
        isRegilyOpen: false,
        isAccountLinkRequested: false,
        hasCompletedBankLinking: false,
        depositAmount: 0,
        bonusCode: '',
    },
    getters,
    actions,
    mutations: {
        [SET_SIGN_UP_STEP](state, step: number) {
            state.step = step;
        },
        [SET_REGILY_OPEN_STATE](state, isOpen: boolean) {
            state.isRegilyOpen = isOpen;
        },
        [SET_ACCOUNT_LINK_REQUESTED](state, isRequested: boolean) {
            state.isAccountLinkRequested = isRequested;
        },
        [SET_BANK_LINKING_COMPLETION](state, isCompleted: boolean) {
            state.hasCompletedBankLinking = isCompleted;
        },
        [SET_DEPOSIT_AMOUNT](state, depositAmount: number) {
            state.depositAmount = depositAmount;
        },
        [SET_BONUS_CODE](state, bonusCode: string) {
            state.bonusCode = bonusCode;
        }
    },
};
